import { images } from "./Assets/assetsHelper";

// Code Develop
// const config = {
//   API_BASE_URL: "https://apistaging.codechallenge-championship.org",
//   REG_LINK: "https://staging.codechallenge-championship.org/firststage",
//   APP_ENV: "development",
//   APP_NAME: "Code Reg",
//   DEFAULT_LANGUAGE: "en",
//   PRIMARY_COLOR: "#6a0505",
//   SECONDARY_COLOR: "#fff",
//   APP_LOGO: images.codelogo,
// };

// Code Production
// const config = {
//   API_BASE_URL: "https://api.codechallenge-championship.org",
//   REG_LINK: "https://codechallenge-championship.org/firststage",
//   APP_ENV: "production",
//   APP_NAME: "Code Reg",
//   DEFAULT_LANGUAGE: "en",
//   PRIMARY_COLOR: "#6a0505",
//   SECONDARY_COLOR: "#fff",
//   APP_LOGO: images.codelogo,
// };

// WeDo Develop
// const config = {
//   API_BASE_URL: "https://apistaging.wedochallenge.org",
//   REG_LINK: "https://staging.wedochallenge.org/firststage",
//   APP_ENV: "development",
//   APP_NAME: "WeDo Reg",
//   DEFAULT_LANGUAGE: "en",
//   PRIMARY_COLOR: "#c11a83",
//   SECONDARY_COLOR: "#fff",
//   APP_LOGO: images.wedologo,
// };

// WeDo Production
// const config = {
//   API_BASE_URL: "https://api.wedochallenge.org",
//   REG_LINK: "https://wedochallenge.org/firststage",
//   APP_ENV: "production",
//   APP_NAME: "WeDo Reg",
//   DEFAULT_LANGUAGE: "en",
//   PRIMARY_COLOR: "#c11a83",
//   SECONDARY_COLOR: "#fff",
//   APP_LOGO: images.wedologo,
// };

// Robot Develop
// const config = {
//   API_BASE_URL: "https://apistaging.international-robotchallenge.org",
//   REG_LINK: "https://apistaging.international-robotchallenge.org/firststage",
//   APP_ENV: "develop",
//   APP_NAME: "Robot Reg",
//   DEFAULT_LANGUAGE: "en",
//   PRIMARY_COLOR: "#830d0b",
//   SECONDARY_COLOR: "#fff",
//   APP_LOGO: images.robotlogo,
// };

// Robot Production
const config = {
  API_BASE_URL: "https://api.international-robotchallenge.org",
  REG_LINK: "https://international-robotchallenge.org/firststage",
  APP_ENV: "production",
  APP_NAME: "Robot Reg",
  DEFAULT_LANGUAGE: "en",
  PRIMARY_COLOR: "#830d0b",
  SECONDARY_COLOR: "#fff",
  APP_LOGO: images.robotlogo,
};

export default config;
